import {Layer} from "./Layer";

export const CreateLayer = `
    mutation createLayer ($input: CreateLayerInput!) {
        createLayer (input: $input) {
            ${Layer}
        }
    }
`;
